var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlagIconEn = function SvgFlagIconEn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "flag-icon_en_svg__a",
    width: 16,
    height: 12,
    x: 1,
    y: 3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 3h16v12H1z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#flag-icon_en_svg__a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E42A5",
    fillRule: "evenodd",
    d: "M1 3v12h16V3H1Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "flag-icon_en_svg__b",
    width: 16,
    height: 12,
    x: 1,
    y: 3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1 3v12h16V3H1Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#flag-icon_en_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "flag-icon_en_svg__c",
    width: 16,
    height: 12,
    x: 1,
    y: 3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 3h16v12H1z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#flag-icon_en_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m-.781 14.143 3.52 1.489L17.08 4.619l1.857-2.213-3.765-.498-5.85 4.746-4.707 3.198-5.396 4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F50100",
    d: "m-.3 15.186 1.794.864L18.27 2.2h-2.518L-.3 15.187Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.782 14.143-3.521 1.489L.92 4.619-.938 2.406l3.765-.498 5.85 4.746 4.707 3.198 5.397 4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F50100",
    d: "m18.662 14.891-1.794.865-7.144-5.93-2.117-.663-8.723-6.75h2.519l8.717 6.59 2.316.795 6.226 5.093Z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "flag-icon_en_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.889 2H7.11v5H.014v4H7.11v5h3.778v-5h7.125V7h-7.125V2Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F50100",
    fillRule: "evenodd",
    d: "M10.889 2H7.11v5H.014v4H7.11v5h3.778v-5h7.125V7h-7.125V2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.111 2V1h-1v1h1Zm3.778 0h1V1h-1v1ZM7.11 7v1h1V7h-1ZM.014 7V6h-1v1h1Zm0 4h-1v1h1v-1Zm7.097 0h1v-1h-1v1Zm0 5h-1v1h1v-1Zm3.778 0v1h1v-1h-1Zm0-5v-1h-1v1h1Zm7.125 0v1h1v-1h-1Zm0-4h1V6h-1v1Zm-7.125 0h-1v1h1V7ZM7.11 3h3.778V1H7.11v2Zm1 4V2h-2v5h2ZM.014 8H7.11V6H.014v2Zm1 3V7h-2v4h2Zm6.097-1H.014v2H7.11v-2Zm1 6v-5h-2v5h2Zm2.778-1H7.11v2h3.778v-2Zm-1-4v5h2v-5h-2Zm8.125-1h-7.125v2h7.125v-2Zm-1-3v4h2V7h-2Zm-6.125 1h7.125V6h-7.125v2Zm-1-6v5h2V2h-2Z",
    mask: "url(#flag-icon_en_svg__d)"
  }))))));
};
export default SvgFlagIconEn;